"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DiscoverHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const rootNavigation_1 = require("./rootNavigation");
const AppText_1 = require("../component/AppText");
const colors_1 = require("../common/colors");
const CreditCounter_1 = __importDefault(require("./CreditCounter"));
const useDevice_1 = require("../hooks/useDevice");
const useAppQuota_1 = require("../hooks/useAppQuota");
const constants_1 = require("../common/constants");
function DiscoverHeader({ drawer, style, ...restProps }) {
    const [isSearchOpen, setIsSearchOpen] = (0, react_1.useState)(false);
    const { deviceWidth } = (0, useDevice_1.useDevice)();
    const { pendingCharacterCount, pendingMessageCount } = (0, useAppQuota_1.useAppQuota)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.header, style], ...restProps, children: [(0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => (0, rootNavigation_1.navigate)('Documents'), style: styles.home, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.logoContainer, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { source: require('../assets/icons/logo.png'), style: styles.logo }) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, fontSize: 24, fontWeight: 600, children: "summaraizer" })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.rightButtons, children: [deviceWidth > 330
                            && pendingCharacterCount <= constants_1.WARNING_CHARACTER_QUOTA
                            && pendingMessageCount <= constants_1.WARNING_CHARACTER_QUOTA
                            && (0, jsx_runtime_1.jsx)(CreditCounter_1.default, {}), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => (0, rootNavigation_1.navigate)('Search'), style: styles.menu, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSearch, color: "white", size: 24 }) }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => { (0, rootNavigation_1.dispatch)(native_1.DrawerActions.toggleDrawer()); }, style: styles.menu, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: drawer ? pro_light_svg_icons_1.faXmark : pro_light_svg_icons_1.faBars, color: "white", size: drawer ? 26 : 25 }) })] })] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    header: {
        height: 72,
        flexDirection: 'row',
    },
    home: {
        gap: 4,
        flexDirection: 'row',
        alignItems: 'center',
        flexGrow: 3,
    },
    logoContainer: {
        width: 32,
        height: 32,
    },
    logo: {
        width: 26,
        height: 32,
    },
    buttons: {
        gap: 16,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    rightButtons: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
    },
    menu: {
        minWidth: 32,
        minHeight: 32,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
